import React from 'react';

interface IBadgeProps {
    text: string;
    color?: 'default' | 'success' | 'warning' | 'error';
    backgroundColor?: string;
    textColor?: string;
}

const Badge: React.FC<IBadgeProps> = (props) => {
    const getColors = (): { backgroundColor: string; textColor: string } => {
        if (props.backgroundColor && props.textColor) {
            return { backgroundColor: props.backgroundColor, textColor: props.textColor };
        }

        switch (props.color) {
            case 'success':
                return { textColor: '#fff', backgroundColor: '#789c2f' };
            case 'warning':
                return { textColor: '#2f2f2f', backgroundColor: '#ffc107' };
            case 'error':
                return { textColor: '#fff', backgroundColor: '#dc3545' };
            default:
                return { textColor: '#212529', backgroundColor: '#e2e9cb' };
        }
    };

    const { backgroundColor, textColor } = getColors();

    return (
        <div style={{
            padding: '2px 8px',
            borderRadius: '4px',
            fontSize: '12px',
            fontWeight: 600,
            backgroundColor,
            color: textColor,
            textAlign: 'center',
            display: 'inline-block',
        }}>
            {props.text}
        </div>
    );
}

export default Badge;